<template>
  <div
    class="lazy-image-container"
    :style="{
      height: heightStyle,
      width: widthStyle
    }"
  >
    <v-skeleton-loader
      v-if="!loaded"
      type="image"
      class="rounded"
      :style="{ height: heightStyle, width: '100%', display: 'block' }"
    />
    <img
      v-show="loaded"
      :src="src"
      :alt="alt"
      @load="onLoad"
      class="lazy-image"
      :style="{
        width: widthStyle,
        height: heightStyle,
        objectFit: 'contain',
        display: 'block'
      }"
    />
  </div>
</template>

<script>
export default {
  name: 'BaseLazyImage',
  props: {
    src: {
      type: String,
      required: true,
    },
    alt: {
      type: String,
      default: '',
    },
    width: {
      type: [String, Number],
      default: '100%',
    },
    height: {
      type: [String, Number],
      default: '100%',
    },
  },
  data() {
    return {
      loaded: false,
    }
  },
  computed: {
    heightStyle() {
      return typeof this.height === 'number' ? `${this.height}px` : this.height
    },
    widthStyle() {
      return typeof this.width === 'number' ? `${this.width}px` : this.width
    },
  },
  methods: {
    onLoad() {
      this.loaded = true
    },
  },
}
</script>

<style scoped>
.lazy-image-container {
  position: relative;
  width: 100%;
}

.lazy-image {
  transition: opacity 0.3s ease;
  border-radius: 4px;
}

::v-deep .v-skeleton-loader__image {
  height: 100%;
  border-radius: 4px; 
}
</style>
